var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"like",class:_vm.activeClass},[_c('span',{staticClass:"like__counter"},[_vm._v(_vm._s(_vm.count))]),_c('i',{staticClass:"like__icon",on:{"click":_vm.likeToggle}})])}
var staticRenderFns = []

export { render, staticRenderFns }